import React from "react";
import { Grid } from "@mui/material";
import LabeledTextArea from "../../Widgets/LabeledTextArea";
import LabeledSelect from "../../Widgets/LabeledSelect";
import LabeledNumber from "../../Widgets/LabeledNumber";
import { DevelopmentalHistoryFormValues } from "./interface";

const TEMPERAMENT_OPTIONS = [
  { value: "EASYGOING", label: "Easygoing" },
  { value: "IRRITABLE", label: "Irritable" },
];

const YES_NO_UNKNOWN_OPTIONS = [
  { value: "YES", label: "Yes" },
  { value: "NO", label: "No" },
  { value: "UNKNOWN", label: "Unknown" },
];

interface EditFieldsProps {
  formValues: DevelopmentalHistoryFormValues;
  handleChange: (
    field: keyof DevelopmentalHistoryFormValues
  ) => (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const EditFields: React.FC<EditFieldsProps> = ({ formValues, handleChange }) => {
  return (
    <Grid container spacing={7}>
      <LabeledTextArea
        label="When did the client's development start to seem different from other children?"
        value={formValues.whenDevelopmentSeemedDifferent}
        onChange={handleChange("whenDevelopmentSeemedDifferent")}
      />
      <LabeledTextArea
        multiline
        label="Complications during pregnancy or immediately after birth"
        value={formValues.complicationsPregnancyBirth}
        onChange={handleChange("complicationsPregnancyBirth")}
      />
      <LabeledNumber
        label="Age (in months) when the client began crawling"
        value={formValues.ageBeganCrawlingMonths ?? 0}
        onChange={handleChange("ageBeganCrawlingMonths")}
        min={0}
      />
      <LabeledNumber
        label="Age (in months) when the client began walking"
        value={formValues.ageBeganWalkingMonths ?? 0}
        onChange={handleChange("ageBeganWalkingMonths")}
        min={0}
      />
      <LabeledNumber
        label="Age (in months) when the client began speaking"
        value={formValues.ageBeganSpeakingMonths ?? 0}
        onChange={handleChange("ageBeganSpeakingMonths")}
        min={0}
      />
      <LabeledSelect
        label="Child temperament in infancy/early childhood"
        value={formValues.childTemperament}
        onChange={handleChange("childTemperament")}
        options={TEMPERAMENT_OPTIONS}
      />
      <LabeledSelect
        label="Was the child interested in being held in infancy/early childhood?"
        value={formValues.interestedInBeingHeld}
        onChange={handleChange("interestedInBeingHeld")}
        options={YES_NO_UNKNOWN_OPTIONS}
      />
      <LabeledSelect
        label="Was the child interested in being played with in infancy/early childhood?"
        value={formValues.interestedInBeingPlayedWith}
        onChange={handleChange("interestedInBeingPlayedWith")}
        options={YES_NO_UNKNOWN_OPTIONS}
      />
      <LabeledSelect
        label="Was the child's caregiver able to attend to the child's needs?"
        value={formValues.caregiverAttendedToNeeds}
        onChange={handleChange("caregiverAttendedToNeeds")}
        options={YES_NO_UNKNOWN_OPTIONS}
      />
      <LabeledTextArea
        multiline
        label="Additional notes related to the client's infancy/early childhood"
        value={formValues.additionalNotesInfancyChildhood}
        onChange={handleChange("additionalNotesInfancyChildhood")}
      />
    </Grid>
  );
};

export default EditFields;
